
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _9k1br05ulQROZbnJQZ4jDHF_45ooZEFMxynQ_45_451_xha0EMeta } from "/usr/src/app/pages/_.vue?macro=true";
import { default as authQ0wt2RNdxCe4_zNNHaE0fwTLv7eEZGM4E0PWRwzGoNkMeta } from "/usr/src/app/pages/auth.vue?macro=true";
import { default as faqsHbe0toH7myFGcyuHvW1CFTyhaDPw96C3bCyIR6gEuBIMeta } from "/usr/src/app/pages/faqs.vue?macro=true";
import { default as indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta } from "/usr/src/app/pages/index.vue?macro=true";
import { default as accountjTFKbZ2nNGMPPqDn9iuMmybrkVNMPrMnjy8JayUz4g4Meta } from "/usr/src/app/pages/account.vue?macro=true";
import { default as autopayGvT7dvPHN1Kf0AmE2Rdp9_zjFpmYPnbyV3wsEpXqCBQMeta } from "/usr/src/app/pages/autopay.vue?macro=true";
import { default as my_45page435uguoNEEE8vWfIE89zaqoDsKTa77I_45qle5K8Rbk38Meta } from "/usr/src/app/pages/my-page.vue?macro=true";
import { default as qrofferzsBX3pHdNT_45HgADgFDuUQf7_45v7uk6oqpUGkreYXP6HYMeta } from "/usr/src/app/pages/qroffer.vue?macro=true";
import { default as index1kKK7j40Y60jCE_45bYIzoEtgKqpoWCC_N6D5sY2nuIbgMeta } from "/usr/src/app/pages/cart/index.vue?macro=true";
import { default as pay_45a_45billrjet6Z4Uz3nf2T_xPT2LqEB8uB54zzTZKhU3bu8scCMMeta } from "/usr/src/app/pages/pay-a-bill.vue?macro=true";
import { default as indexBjBIjspoTOpKpqIL6knEj7TdQlJZMiEZ3ySYonQm1CsMeta } from "/usr/src/app/pages/learn/index.vue?macro=true";
import { default as out_45of_45areaq0MYHtJ01ujiqS55dhOaYvVRkgHw0wvTL76njZfh4aEMeta } from "/usr/src/app/pages/out-of-area.vue?macro=true";
import { default as index7Nc4gGG6Ut6CVZJtb7m7opzGuI_45ggoYDFeYOmh9UafMMeta } from "/usr/src/app/pages/survey/index.vue?macro=true";
import { default as indext3z09_45scoHG8gYUHIkXhy29Bw9doDSwQ9ml0Rw6_YnAMeta } from "/usr/src/app/pages/careers/index.vue?macro=true";
import { default as indexALMqY_45kS2gImK5XxL0fNF3Tayx2_45xS4wBlf9pEgykNcMeta } from "/usr/src/app/pages/about-us/index.vue?macro=true";
import { default as autopayXiz83LZv8Vl0AprWD8VONfgXJM1wReUHb0nCItUf_E0Meta } from "/usr/src/app/pages/portal/autopay.vue?macro=true";
import { default as indexzw2uLHyqkI9xDcZJvKpOvj83FJP4svIeH7wYZulHdDgMeta } from "/usr/src/app/pages/services/index.vue?macro=true";
import { default as single_45wnbxoNeEgKhWeZ8CNjMxe76L8rxDy0km_lTaSOtdN8Meta } from "/usr/src/app/pages/checkout/single.vue?macro=true";
import { default as payment_45options7r8j5C3VZgeShQiV1ywtln1dYdhEdKQmprk6i3X0yvUMeta } from "/usr/src/app/pages/payment-options.vue?macro=true";
import { default as _91slug_93OxNm9cbyzvC1WwcktZe4WicpNRLePDSwLwhJnrmHQz8Meta } from "/usr/src/app/pages/policies/[slug].vue?macro=true";
import { default as feedbackFZd4o7BDAgPvT5sQExaLsXPSFh2Dku0gUKI_jYrZvbkMeta } from "/usr/src/app/pages/portal/feedback.vue?macro=true";
import { default as registerTS9dIPoKVZ6rBtJh2D5ZRcjlHXr0maGqfJKjgPlfMsQMeta } from "/usr/src/app/pages/portal/register.vue?macro=true";
import { default as servicesG5WfmjHawl1ZeBzDUmpdz_45BzFnIetVhZlt_45nuL5O8YQMeta } from "/usr/src/app/pages/portal/services.vue?macro=true";
import { default as _91slug_937fUGEd8aW87y8_45KTp68vSiSD0aiKE1xCEhtsAoA9FP0Meta } from "/usr/src/app/pages/services/[slug].vue?macro=true";
import { default as listingsWEH7kWdJbKandETo8fNj70MJqAGBVRNlPyGYpXUKTNgMeta } from "/usr/src/app/pages/careers/listings.vue?macro=true";
import { default as thank_45you8U8EeYu2GY29aSuWbYjx5i0maqRF7NidP5GCQVgIL6EMeta } from "/usr/src/app/pages/portal/thank-you.vue?macro=true";
import { default as thank_45youQfUi_45_45PkNv9u3QYnF0hdUb7dLZ6FiZPOTg_45KU5ZIf_sMeta } from "/usr/src/app/pages/survey/thank-you.vue?macro=true";
import { default as indexSjwADDrbUKPCetHZyFPn3eDjmQKaphmZaCMemm59ZQUMeta } from "/usr/src/app/pages/learn/blogs/index.vue?macro=true";
import { default as pay_45a_45bill339GtksDG8V_45d1myNTF_uDLTqD9Y_45UVjBuF4_45JFwUV0Meta } from "/usr/src/app/pages/portal/pay-a-bill.vue?macro=true";
import { default as index51XmUeSMyIy2_RVvJ6QPlnynSSWKfmMurZzFjmMRp5EMeta } from "/usr/src/app/pages/testimonial/index.vue?macro=true";
import { default as thank_45youLmSmuGuu8iDEsnyw_45W5u77uEzY_455Ns0aQxpQDD_45ah3IMeta } from "/usr/src/app/pages/checkout/thank-you.vue?macro=true";
import { default as _91slug_93jwaIr5uE4FIFnUQAZvax8e0yl_45jfs4raxNB0H_FxGgkMeta } from "/usr/src/app/pages/learn/blogs/[slug].vue?macro=true";
import { default as property_45evaluationhMJ1Rum_45CxSZ0lG5LsORbUX_3Rw9hNtYC4_yhp_KA_AMeta } from "/usr/src/app/pages/property-evaluation.vue?macro=true";
import { default as indexlcZLBLWUAu2QnOKrHs1ynQRpfMBtGuTxdx5vGB1RZ5QMeta } from "/usr/src/app/pages/learn/glossary/index.vue?macro=true";
import { default as _91slug_93_45Pk1Zy6xwaELuIMrwRaPfKv6WWu4S5y5YgcoohZgNSYMeta } from "/usr/src/app/pages/learn/glossary/[slug].vue?macro=true";
import { default as payment_45history6uEl863e7Y4KXeZl1FgcVGpZruvrA5_45jvnILGJMpRfMMeta } from "/usr/src/app/pages/portal/payment-history.vue?macro=true";
import { default as service_45historyW2F_452_m1Gvo_4539Mw0EnxPA8_piPUYt6AE_l617rSfAEMeta } from "/usr/src/app/pages/portal/service-history.vue?macro=true";
import { default as customer_45surveyxQel512UQF9vJ0P9WyTnLJQaLm4NFHqDD2hn134XFAAMeta } from "/usr/src/app/pages/survey/customer-survey.vue?macro=true";
import { default as _91slug_93hE9In_45WDEjSFVp3mVk0fSH3GXe8D5lu1iOXr_ZrpGSIMeta } from "/usr/src/app/pages/ppc-landing-page/[slug].vue?macro=true";
import { default as indexZYr_45lcelhYtJfY8GTBH5YciRVIoKrfHS9ib_kkjDBssMeta } from "/usr/src/app/pages/services/mosquito/index.vue?macro=true";
import { default as indexUjCrXoqIBdiVGwnpNsqUsUMQKBf0LcbRaTriAlEfFQcMeta } from "/usr/src/app/pages/lawn-care-locations/index.vue?macro=true";
import { default as _91slug_93Gzs56bBsAOsigbTfWzVOhEwyc3uVHbSBIeILLA54yFYMeta } from "/usr/src/app/pages/lawn-care-locations/[slug].vue?macro=true";
import { default as account_45informationiJR4kdOYPTmvuIW5q2s7k2h9yhoadknJJv1jhBcca7oMeta } from "/usr/src/app/pages/portal/account-information.vue?macro=true";
import { default as property_45evaluationhmvuewTzEF9JoPkAcfz5n7kv_EvUYte4EjZDgHViEu0Meta } from "/usr/src/app/pages/portal/property-evaluation.vue?macro=true";
import { default as indexlQKxioQ13_139AzOxbHfjNet4Olst8SggNN7ocpRblUMeta } from "/usr/src/app/pages/services/ant-control/index.vue?macro=true";
import { default as our_45green_45approachXJ7GCwAnRQJMLqPjhZ_v3zA13LbXuvYM0dcsopTmeqwMeta } from "/usr/src/app/pages/about-us/our-green-approach.vue?macro=true";
import { default as indexkC_45GUrYXK_45vma1MITX3nUEkZnrvfjlo2pVHhovwuVM4Meta } from "/usr/src/app/pages/learn/lawn-care-guides/index.vue?macro=true";
import { default as indexljhoWxjALVWOdb7IbBd6bmtoSi2qvHx1QyG76kQZ48cMeta } from "/usr/src/app/pages/learn/tree-care-guides/index.vue?macro=true";
import { default as index_viiwGfWYkiuwOju8w6Gb5JJAYMq4rbpdiA1LkzEfw0Meta } from "/usr/src/app/pages/services/pest-services/index.vue?macro=true";
import { default as contact_45spring_45greens2fwGgo8RbmXXd_454eugCh0Vsz0BiiWbb7_45AMhI3_J1cMeta } from "/usr/src/app/pages/about-us/contact-spring-green.vue?macro=true";
import { default as _91slug_93SEvsYk5PCpXr3GRnaLdLiREL_45Pv_vh_45OdVrU0oDd4CIMeta } from "/usr/src/app/pages/learn/lawn-care-guides/[slug].vue?macro=true";
import { default as _91slug_932D9v2KENIhaRB3RaxWTZDuiM1CwQLNhuafCl91dtpHcMeta } from "/usr/src/app/pages/learn/tree-care-guides/[slug].vue?macro=true";
import { default as change_45service_45addresspyuZy4bfEK3GmbGmIi20OXbX7aLPv79sZr4Ri7xwsN8Meta } from "/usr/src/app/pages/portal/change-service-address.vue?macro=true";
import { default as indexXD8g6MPje2q4uJQG0VwvjFPvAoqp3fBUJeCIWSgDIfoMeta } from "/usr/src/app/pages/learn/pest-control-guides/index.vue?macro=true";
import { default as _91slug_93DyWH6i8d37FSe_45JH_45ZfGpMDcFCFTMcPhB9iAQjZPxCQMeta } from "/usr/src/app/pages/learn/pest-control-guides/[slug].vue?macro=true";
import { default as index9SZSETqxKY_gkn_xTob3xhSUFzXYRsu4p1yDRtAroE4Meta } from "/usr/src/app/pages/services/lawn-care-services/index.vue?macro=true";
import { default as _91slug_93t0_N1cBjdz9KhhhuXiuAA5HCBJ9lIzDIeM_450gssZYowMeta } from "/usr/src/app/pages/learn/lawn-care-guides/topics/[slug].vue?macro=true";
import { default as _91slug_93Z0P49EnMyzCPcVc4um0Y_45dCt4LXzvcl50QgYHq2LtfYMeta } from "/usr/src/app/pages/learn/tree-care-guides/topics/[slug].vue?macro=true";
import { default as indexsS1Hh2_452DLNfAhRtdhCg5LWiXcIqKVXUGHRgslCNY6cMeta } from "/usr/src/app/pages/services/tree-and-shrub-services/index.vue?macro=true";
import { default as _91slug_93irKOJa_yfLxklEs_453Ph78MGuZHCGlbUvl5ERaQ0yUCwMeta } from "/usr/src/app/pages/learn/pest-control-guides/topics/[slug].vue?macro=true";
import { default as customer_45care_45internal_45company_45ownedFaDcNaLR_X0GTvvj3kJ9oGrA159wCbFweE2Otw3NgzkMeta } from "/usr/src/app/pages/survey/customer-care-internal-company-owned.vue?macro=true";
export default [
  {
    name: "_",
    path: "/_",
    component: () => import("/usr/src/app/pages/_.vue")
  },
  {
    name: "auth",
    path: "/auth",
    component: () => import("/usr/src/app/pages/auth.vue")
  },
  {
    name: "faqs",
    path: "/faqs",
    component: () => import("/usr/src/app/pages/faqs.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: accountjTFKbZ2nNGMPPqDn9iuMmybrkVNMPrMnjy8JayUz4g4Meta || {},
    component: () => import("/usr/src/app/pages/account.vue")
  },
  {
    name: "autopay",
    path: "/autopay",
    component: () => import("/usr/src/app/pages/autopay.vue")
  },
  {
    name: "my-page",
    path: "/my-page",
    component: () => import("/usr/src/app/pages/my-page.vue")
  },
  {
    name: "qroffer",
    path: "/qroffer",
    component: () => import("/usr/src/app/pages/qroffer.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/usr/src/app/pages/cart/index.vue")
  },
  {
    name: "pay-a-bill",
    path: "/pay-a-bill",
    component: () => import("/usr/src/app/pages/pay-a-bill.vue")
  },
  {
    name: "learn",
    path: "/learn",
    component: () => import("/usr/src/app/pages/learn/index.vue")
  },
  {
    name: "out-of-area",
    path: "/out-of-area",
    component: () => import("/usr/src/app/pages/out-of-area.vue")
  },
  {
    name: "survey",
    path: "/survey",
    component: () => import("/usr/src/app/pages/survey/index.vue")
  },
  {
    name: "careers",
    path: "/careers",
    component: () => import("/usr/src/app/pages/careers/index.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/usr/src/app/pages/about-us/index.vue")
  },
  {
    name: "portal-autopay",
    path: "/portal/autopay",
    component: () => import("/usr/src/app/pages/portal/autopay.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/usr/src/app/pages/services/index.vue")
  },
  {
    name: "checkout-single",
    path: "/checkout/single",
    component: () => import("/usr/src/app/pages/checkout/single.vue")
  },
  {
    name: "payment-options",
    path: "/payment-options",
    component: () => import("/usr/src/app/pages/payment-options.vue")
  },
  {
    name: "policies-slug",
    path: "/policies/:slug()",
    component: () => import("/usr/src/app/pages/policies/[slug].vue")
  },
  {
    name: "portal-feedback",
    path: "/portal/feedback",
    component: () => import("/usr/src/app/pages/portal/feedback.vue")
  },
  {
    name: "portal-register",
    path: "/portal/register",
    component: () => import("/usr/src/app/pages/portal/register.vue")
  },
  {
    name: "portal-services",
    path: "/portal/services",
    component: () => import("/usr/src/app/pages/portal/services.vue")
  },
  {
    name: "services-slug",
    path: "/services/:slug()",
    component: () => import("/usr/src/app/pages/services/[slug].vue")
  },
  {
    name: "careers-listings",
    path: "/careers/listings",
    component: () => import("/usr/src/app/pages/careers/listings.vue")
  },
  {
    name: "portal-thank-you",
    path: "/portal/thank-you",
    component: () => import("/usr/src/app/pages/portal/thank-you.vue")
  },
  {
    name: "survey-thank-you",
    path: "/survey/thank-you",
    component: () => import("/usr/src/app/pages/survey/thank-you.vue")
  },
  {
    name: "learn-blogs",
    path: "/learn/blogs",
    component: () => import("/usr/src/app/pages/learn/blogs/index.vue")
  },
  {
    name: "portal-pay-a-bill",
    path: "/portal/pay-a-bill",
    component: () => import("/usr/src/app/pages/portal/pay-a-bill.vue")
  },
  {
    name: "testimonial",
    path: "/testimonial",
    component: () => import("/usr/src/app/pages/testimonial/index.vue")
  },
  {
    name: "checkout-thank-you",
    path: "/checkout/thank-you",
    component: () => import("/usr/src/app/pages/checkout/thank-you.vue")
  },
  {
    name: "learn-blogs-slug",
    path: "/learn/blogs/:slug()",
    component: () => import("/usr/src/app/pages/learn/blogs/[slug].vue")
  },
  {
    name: "property-evaluation",
    path: "/property-evaluation",
    component: () => import("/usr/src/app/pages/property-evaluation.vue")
  },
  {
    name: "learn-glossary",
    path: "/learn/glossary",
    component: () => import("/usr/src/app/pages/learn/glossary/index.vue")
  },
  {
    name: "learn-glossary-slug",
    path: "/learn/glossary/:slug()",
    component: () => import("/usr/src/app/pages/learn/glossary/[slug].vue")
  },
  {
    name: "portal-payment-history",
    path: "/portal/payment-history",
    component: () => import("/usr/src/app/pages/portal/payment-history.vue")
  },
  {
    name: "portal-service-history",
    path: "/portal/service-history",
    component: () => import("/usr/src/app/pages/portal/service-history.vue")
  },
  {
    name: "survey-customer-survey",
    path: "/survey/customer-survey",
    component: () => import("/usr/src/app/pages/survey/customer-survey.vue")
  },
  {
    name: "ppc-landing-page-slug",
    path: "/ppc-landing-page/:slug()",
    meta: _91slug_93hE9In_45WDEjSFVp3mVk0fSH3GXe8D5lu1iOXr_ZrpGSIMeta || {},
    component: () => import("/usr/src/app/pages/ppc-landing-page/[slug].vue")
  },
  {
    name: "services-mosquito",
    path: "/services/mosquito",
    component: () => import("/usr/src/app/pages/services/mosquito/index.vue")
  },
  {
    name: "lawn-care-locations",
    path: "/lawn-care-locations",
    component: () => import("/usr/src/app/pages/lawn-care-locations/index.vue")
  },
  {
    name: "lawn-care-locations-slug",
    path: "/lawn-care-locations/:slug()",
    component: () => import("/usr/src/app/pages/lawn-care-locations/[slug].vue")
  },
  {
    name: "portal-account-information",
    path: "/portal/account-information",
    component: () => import("/usr/src/app/pages/portal/account-information.vue")
  },
  {
    name: "portal-property-evaluation",
    path: "/portal/property-evaluation",
    component: () => import("/usr/src/app/pages/portal/property-evaluation.vue")
  },
  {
    name: "services-ant-control",
    path: "/services/ant-control",
    component: () => import("/usr/src/app/pages/services/ant-control/index.vue")
  },
  {
    name: "about-us-our-green-approach",
    path: "/about-us/our-green-approach",
    component: () => import("/usr/src/app/pages/about-us/our-green-approach.vue")
  },
  {
    name: "learn-lawn-care-guides",
    path: "/learn/lawn-care-guides",
    component: () => import("/usr/src/app/pages/learn/lawn-care-guides/index.vue")
  },
  {
    name: "learn-tree-care-guides",
    path: "/learn/tree-care-guides",
    component: () => import("/usr/src/app/pages/learn/tree-care-guides/index.vue")
  },
  {
    name: "services-pest-services",
    path: "/services/pest-services",
    component: () => import("/usr/src/app/pages/services/pest-services/index.vue")
  },
  {
    name: "about-us-contact-spring-green",
    path: "/about-us/contact-spring-green",
    component: () => import("/usr/src/app/pages/about-us/contact-spring-green.vue")
  },
  {
    name: "learn-lawn-care-guides-slug",
    path: "/learn/lawn-care-guides/:slug()",
    component: () => import("/usr/src/app/pages/learn/lawn-care-guides/[slug].vue")
  },
  {
    name: "learn-tree-care-guides-slug",
    path: "/learn/tree-care-guides/:slug()",
    component: () => import("/usr/src/app/pages/learn/tree-care-guides/[slug].vue")
  },
  {
    name: "portal-change-service-address",
    path: "/portal/change-service-address",
    component: () => import("/usr/src/app/pages/portal/change-service-address.vue")
  },
  {
    name: "learn-pest-control-guides",
    path: "/learn/pest-control-guides",
    component: () => import("/usr/src/app/pages/learn/pest-control-guides/index.vue")
  },
  {
    name: "learn-pest-control-guides-slug",
    path: "/learn/pest-control-guides/:slug()",
    component: () => import("/usr/src/app/pages/learn/pest-control-guides/[slug].vue")
  },
  {
    name: "services-lawn-care-services",
    path: "/services/lawn-care-services",
    component: () => import("/usr/src/app/pages/services/lawn-care-services/index.vue")
  },
  {
    name: "learn-lawn-care-guides-topics-slug",
    path: "/learn/lawn-care-guides/topics/:slug()",
    component: () => import("/usr/src/app/pages/learn/lawn-care-guides/topics/[slug].vue")
  },
  {
    name: "learn-tree-care-guides-topics-slug",
    path: "/learn/tree-care-guides/topics/:slug()",
    component: () => import("/usr/src/app/pages/learn/tree-care-guides/topics/[slug].vue")
  },
  {
    name: "services-tree-and-shrub-services",
    path: "/services/tree-and-shrub-services",
    component: () => import("/usr/src/app/pages/services/tree-and-shrub-services/index.vue")
  },
  {
    name: "learn-pest-control-guides-topics-slug",
    path: "/learn/pest-control-guides/topics/:slug()",
    component: () => import("/usr/src/app/pages/learn/pest-control-guides/topics/[slug].vue")
  },
  {
    name: "survey-customer-care-internal-company-owned",
    path: "/survey/customer-care-internal-company-owned",
    component: () => import("/usr/src/app/pages/survey/customer-care-internal-company-owned.vue")
  }
]